import styled from "styled-components";

export const PriceBox = styled.div`
    padding: 0.8rem 1.6rem;
    background-color: ${({ theme }) => theme.color.neutral50};
    border: 1px solid ${({ theme }) => theme.color.neutral100};
    border-radius: ${({ theme }) => theme.radius.default};
    display: grid;
    grid-auto-flow: row;
    gap: 0.8rem;
`;
